import { FeatureLangModelType } from '@teinor/erp/types/company/product/feature/featureLang'
import { FeatureValueModelType } from '@teinor/erp/types/company/product/feature/featureValue'
import { useParams } from 'react-router-dom'
import { ModalCreateEditMediumLoading, MediumModalCreateEdit } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { getLang } from '../../../../../../../../utils/globals'
import { useBasicData } from '../../../../../../../../utils/hooks/useBasicData'
import useLangData from '../../../../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { getActiveLangs } from '../../../../../../../../utils/reducers/getters'

interface ModalCEFeatureValueProps extends ModalEditComponentProps { }

interface ModifiedFeatureValueModelType extends FeatureValueModelType {
    featureValueLangs: string
}
const ModalCEFeatureValue: React.FC<ModalCEFeatureValueProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const myLang = getLang()
    const params = useParams<{ FeatureId?: string }>()
    const { basicData } = useBasicData({ url: '/api/app/product/feature/featureValue/getFeatureValueInstance', params: { id: allRowData?.id }, doPetition: allRowData !== undefined })
    const { changeLang, selectedLang, data, changeValCurrentLang } = useLangData({ myData: basicData?.FeatureValueLangs, fieldsToLang: ['name'], keyValue: 'LangId' })
    const fields: FormRender<FeatureLangModelType & ModifiedFeatureValueModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: myLang,
                    onChange: changeLang,
                    required: true
                },
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                    lang: selectedLang,
                    value: data?.['name'][selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('name', name)
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: allRowData?.id
                },
                {
                    name: 'FeatureId',
                    component: 'InputHidden',
                    value: params?.FeatureId
                },
                {
                    name: 'featureValueLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.name)
                },
            ]
        }
    ]
    if (allRowData && userPermissions) {
        return (
            <ModalCreateEditMediumLoading fields={fields} url={'/api/app/product/feature/featureValue/updateFeatureValue'} translations={{ title: t('editFeatureValue', 'Editar Valor de característica') + ' - ' + allRowData?.['FeatureValueLangs.name'], button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} loading={data ? false : true} />
        )
    }
    return (
        <MediumModalCreateEdit fields={fields} url={'/api/app/product/feature/featureValue/createFeatureValue'} translations={{
            title: t('createFeatureValue', 'Crear valor de característica'),
            button: t('create', 'Crear')
        }} haveButtonPermissions={true} {...rest} />
    )
}

export default ModalCEFeatureValue